import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from './product-colour-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.object
}

const defaultProps = {
  hiddenColumns : [],
  isLoading     : false
}

/**
 * Table to display Product Colour columns
 * @param {Array<Object>} data - array of product colours objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const ProductColourTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  isLoading,
  rowButtonProps
}) => {
  const {
    handleEnableColour,
    handleDisableColour,
    handleOpenUpdateModal
  } = rowButtonProps

  const columns = useMemo(() => tableColumns({
    handleEnableColour,
    handleDisableColour,
    handleOpenUpdateModal
  }), [
    handleEnableColour,
    handleDisableColour,
    handleOpenUpdateModal
  ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

ProductColourTable.propTypes    = propTypes
ProductColourTable.defaultProps = defaultProps

export default ProductColourTable
